{
  "internalDescription": "Fresh start",
  "externalDescription": {
    "de": "Neustart",
    "fr": "Nouveau départ",
    "es": "Nuevo comienzo",
    "it": "Nuovo inizio",
    "en": "Fresh start",
    "pt": "Novo começo"
  },
  "rid": 0.12,
  "entitySetVersion": 1,
  "envs": {
    "staging": {
      "featureFlags": {
        "support": [
          "ALL"
        ],
        "debugScreen": [
          "ALL",
          "staff"
        ],
        "allowShorebirdPatchInstall": [
          "staff"
        ]
      },
      "enabledSegments": [
        "ALL"
      ],
      "parameters": {
        "gracePeriodInMin_n": 43200,
        "translationsVersion_n": 283,
        "defaultThemeColor": "a",
        "defaultThemeMode": "dark"
      },
      "enabledPlatforms": [
        "ios",
        "android",
        "web",
        "windows",
        "mac"
      ]
    },
    "dev": {
      "enabledSegments": [
        "ALL"
      ],
      "featureFlags": {
        "support": [
          "ALL"
        ],
        "debugScreen": [
          "ALL"
        ],
        "allowShorebirdPatchInstall": [
          "ALL",
          "staff"
        ]
      },
      "enabledPlatforms": [
        "web",
        "windows",
        "mac",
        "ios",
        "android"
      ],
      "parameters": {
        "translationsVersion_n": 283,
        "gracePeriodInMin_n": 43200,
        "defaultThemeColor": "a",
        "defaultThemeMode": "dark"
      }
    },
    "hotfix": {
      "featureFlags": {
        "support": [
          "ALL"
        ],
        "debugScreen": [
          "ALL"
        ],
        "allowShorebirdPatchInstall": [
          "ALL",
          "first_reward",
          "staff"
        ]
      },
      "enabledPlatforms": [
        "ios",
        "web",
        "android",
        "windows",
        "mac",
        "linux"
      ],
      "enabledSegments": [
        "ALL"
      ],
      "parameters": {
        "gracePeriodInMin_n": 43200,
        "translationsVersion_n": 283,
        "defaultThemeColor": "a",
        "defaultThemeMode": "dark"
      }
    },
    "prod": {
      "enabledSegments": [
        "ALL"
      ],
      "featureFlags": {
        "support": [
          "ALL"
        ],
        "allowShorebirdPatchInstall": [
          "staff"
        ],
        "debugScreen": [
          "staff"
        ]
      },
      "enabledPlatforms": [],
      "parameters": {
        "translationsVersion_n": 283,
        "gracePeriodInMin_n": 43200,
        "defaultThemeColor": "a",
        "defaultThemeMode": "dark"
      }
    },
    "qa": {
      "featureFlags": {
        "support": [
          "ALL"
        ],
        "debugScreen": [
          "ALL"
        ],
        "allowShorebirdPatchInstall": [
          "ALL",
          "staff"
        ]
      },
      "enabledPlatforms": [
        "web",
        "windows",
        "mac",
        "ios",
        "android"
      ],
      "parameters": {
        "translationsVersion_n": 283,
        "gracePeriodInMin_n": 43200,
        "defaultThemeColor": "a",
        "defaultThemeMode": "dark"
      },
      "enabledSegments": [
        "ALL"
      ]
    }
  },
  "id": "c5f9a88e-6342-461f-9e52-a7f5c6117ac8",
  "deletedAt": null
}
